var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{class:_vm.tabMeta.tabEl.tabClass},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.tabMeta.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }